import { awaitRequests, promise } from '../../../helpers';
import { firebaseDelete } from '../firebase';

const deleteFacilitatorManager = (docId, where) => {
    // eslint-disable-next-line
    return (dispatch, getState, getFirebase) => {
        // after delete
        const afterDelete = item => {
            const reqs = [];

            return awaitRequests(reqs).then(() => promise(item));
        };

        // -- delete by docId
        if (docId) {
            return dispatch(firebaseDelete({ collection: 'facilitatorsManagers', docId })).then(item => afterDelete(item));
        }

        // -- delete where
        if (where) {
            return dispatch(firebaseDelete({ collection: 'facilitatorsManagers', where })).then(deletedItems =>
                awaitRequests(deletedItems.map(item => afterDelete(item))),
            );
        }

        return promise();
    };
};

export default deleteFacilitatorManager;
